import axios from 'axios';
import config from '~/config';
import * as customError from '~/models/error'

export const useSearchStore = defineStore('search', {
    state: () => ({
        vocabularySearchData: [],
        quranSearchData: [],
        cancelTokenSource: null // Store the cancel token source
    }),
    actions: {
        async vocabularyAutoComplete(params) {
            // Cancel the previous request if it exists
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('Operation canceled due to new request.');
            }

            // Create a new cancel token source
            this.cancelTokenSource = axios.CancelToken.source();

            try {
                const url = `${config.API_BASE_URL}/api/Vocabulary/Facet`;
                const serviceResult = await axios.get(url, {
                    params,
                    cancelToken: this.cancelTokenSource.token // Use the cancel token
                });
                const data = serviceResult?.data;
                if (!data?.Data.length) {
                    throw new customError.NoContent(serviceResult, url);
                }
                this.vocabularySearchData = data.Data;
                return this.vocabularySearchData;
            } catch (err) {
                if (axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else {
                    console.log({ err });
                }
            }
        },

        async quranAutoComplete(params) {
            // Cancel the previous request if it exists
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('Operation canceled due to new request.');
            }

            // Create a new cancel token source
            this.cancelTokenSource = axios.CancelToken.source();

            try {
                const url = `${config.API_BASE_URL}/api/Search/AutoComplete`;
                const serviceResult = await axios.get(url, {
                    params,
                    cancelToken: this.cancelTokenSource.token // Use the cancel token
                });
                const data = JSON.parse(serviceResult.data);
                if (!data?.data?.resultList?.length) {
                    throw new customError.NoContent(serviceResult, url);
                }
                this.quranSearchData = data.data.resultList;
                return this.quranSearchData;
            } catch (err) {
                if (axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else {
                    console.log({ err });
                }
            }
        },
    },})